/**
 * Hemisphere fill and the shadow-casting sun (GDD §3.1; concept L662–L668).
 */
import { DirectionalLight, HemisphereLight, Scene, Vector3 } from 'three';
import type { Look } from './looks.ts';

export interface Lights {
  hemi: HemisphereLight;
  sun: DirectionalLight;
  sunDir: Vector3;
  /** Centres the sun and its shadow area on (x, z) (concept L668). */
  aim(x: number, z: number): void;
}

export function createLights(scene: Scene, look: Look, shadowHalfExtent: number, shadowMapSize: number): Lights {
  const sunDir = new Vector3().fromArray(look.sunDir).normalize();
  const hemi = new HemisphereLight(look.hemiSky, look.hemiGround, look.hemi);
  scene.add(hemi);
  const sun = new DirectionalLight(look.sunLight, look.sun);
  sun.castShadow = true;
  sun.shadow.mapSize.set(shadowMapSize, shadowMapSize);
  const sc = sun.shadow.camera;
  sc.left = -shadowHalfExtent;
  sc.right = shadowHalfExtent;
  sc.top = shadowHalfExtent;
  sc.bottom = -shadowHalfExtent;
  sc.near = 1;
  sc.far = 1400;
  sun.shadow.bias = -0.0004;
  sun.shadow.normalBias = 0.6;
  scene.add(sun);
  scene.add(sun.target);
  return {
    hemi,
    sun,
    sunDir,
    aim(x, z) {
      sun.target.position.set(x, 0, z);
      sun.position.set(x, 0, z).addScaledVector(sunDir, 600);
    },
  };
}
